
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import news from "../../static/news/yongyou1.png"
import news3 from "../../static/news/yongyou3.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'4'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>用友与深圳远东数智采共同推出的公共资源交易行业垂类大模型入选“北京首批‘人工智能+’应用场景典型案例</h3>
          <div className='time'>发布时间：2024-08-19</div>
          <div className='newsCon-con'>
            <p style={{textAlign:'center'}}><img src={news} /></p>
            <p>8月19日，由北京市发展和改革委员会、北京市科学技术协会、北京市海淀区人民政府等主办的2024北京人工智能生态大会在北京中关村国家自主创新示范区隆重举行，大会围绕大模型、具身智能、可信AI等国内外前沿热点话题展开深入探讨，并重磅发布了“北京首批‘人工智能+’应用场景十佳案例和北京首批‘人工智能+’应用场景典型案例”，用友联合中交信科联合共研的交通建设行业垂类大模型从300+申报案例中脱颖而出，成功入选“北京首批‘人工智能+’应用场景十佳案例”，同时用友与深圳远东数智采共同推出的公共资源交易行业垂类大模型入选“北京首批‘人工智能+’应用场景典型案例”。</p>
            <p style={{textAlign:'center'}}><img src={news3} /></p>
            <p>此次入选十佳案例的是用友联合深圳市远东数智采共同打造的公共资源交易行业大模型,该模型具备在公共资源交易中提供专业知识问答、招标文件自动生成、智能投标评审、交易价格预测等能力，以帮助招采业务实现评审决策智能化、全流程数智化管理以及风险有效识别与防控，显著提升招投标的效率及专业性，促进市场公平竞争。</p>
          </div>
        </div>
      </PageBox>
    </>
  );
}
